/**
 * 建议不引入其他
 */
import Vue from "vue";

var LANG = {
  langs: [{
    key: 'zh',
    name: '简'
  }, {
    key: 'hk',
    name: '繁'
  }, {
    key: 'en',
    name: 'EN'
  }],
  langsArray: [],
  current: 'zh',
  langLib: {},
  keyLang: false,
  filter: function (key, attr) {
    if (!key || LANG.langsArray.indexOf(LANG.current) == -1 || typeof LANG.langLib[key] ===
      'undefined') {
      return key;
    }
    let target = LANG.langLib[key];
    if (target[LANG.current]) {
      // 传参 替换
      if (attr instanceof Array) {
        let data = target[LANG.current]
        attr.forEach((item, index) => {
          data = data.replace(`{${index}}`, item)
        })

        return data
      }
      return target[LANG.current];
    }
    return (LANG.keyLang ? (key || target[LANG.langsArray.find(d => target[d])]) : (target[LANG
        .langsArray.find(d => target[d])] || key)) ||
      key;

  },
  set: function ({
    langLib,
    lang,
    keyLang,
    reload = false
  }) {
    if (langLib) {
      LANG.langLib = {
        ...LANG.langLib,
        ...langLib
      };
    }
    if (lang && LANG.langsArray.indexOf(lang) > -1) {
      LANG.current = lang;
      init(lang, reload)
    }
    if (typeof keyLang !== 'undefined') {
      LANG.keyLang = !!keyLang;
    }

  }
};
const langsArray = LANG.langs.map(d => d.key);
LANG.langsArray = langsArray;


var init = (key, reload = false) => {
  if(Vue.prototype.$isServer){
    return
  }

  let localLang = window.localStorage.getItem('lang');
  let current = key || localLang || LANG.langsArray[0];
  if (localLang !== current) {
    window.localStorage.setItem('lang', current) ;
  }

	LANG.current = current;

  if (reload) {
    window.location.reload();
  }else if(!window.L){
		window.L = LANG.filter;
	}
}
init();


export default LANG;
export const set = LANG.set
export const langs = LANG.langs
export const lang = LANG.current



// WEBPACK FOOTER //
// ./../../plugins/lang.js